import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tooltip, Icon, Upload, message } from "antd";
import InputForm from "./InputForm";
import { CPFValido, CNPJValido } from '../utils/Validator';
import { maskTelefone, maskCNPJ, maskCPF, limparCpfCnpj } from '../utils/Masker';
import "./Form.css";
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone"; // VALIDAR DATAS
import MunicipioFrame from './MunicipioFrame';

const { Item: ItemForm } = Form;

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Você só pode enviar arquivos JPG / PNG!');
  }
  const isLt2M = file.size / 1024 / 1024 < 0.1;
  if (!isLt2M) {
    message.error('A imagem deve ter menos de 100 KB!');
  }
  return isJpgOrPng && isLt2M;
}



export default class EmpresaForm extends Component {
  state = {
    registro: {
      emp_codigo: '',
      emp_nome: '',
      emp_razao_social: '',
      emp_situacao: '',
      emp_cpf_cnpj: '',
      emp_cep: '',
      emp_endereco: '',
      emp_numero: '',
      emp_complemento: '',
      emp_bairro: '',
      emp_municipio: { key: '0' },
      emp_filial: '',
      emp_filial1: '',
      emp_licencas: '0',
      emp_data_contrato: moment().format('DD/MM/YYYY'),
      emp_vlr_mensal: 0,
      emp_obs: '',
      par_local_servidor: 'UNICO',
      par_codigo_liberar_senha: '',
      par_entrega_itens_vendas: 0,
      par_flag_impr_ped_sem_descon: 0,
      par_exportar_orcamentos: 0,

      imgNome: '',
      imgSize: '0',
      imgData: '',
      base64: '',
      pathImagem: null,
    },
    loading: false,
  };

  componentDidMount() {
  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {

      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangeMunicipio = event => {
    const { registro } = this.state;
    registro['emp_municipio'] = event.emp_municipio;
    this.setState(event);
  }

  normalizeCpfCnpj = () => {
    const { registro } = this.state;
    const cpfcnpj = limparCpfCnpj(registro.emp_cpf_cnpj);

    if (!cpfcnpj) return;

    this.setState({
      registro: {
        ...registro,
        emp_cpf_cnpj: /^[0-9]{11}$/.test(cpfcnpj)
          ? maskCPF(cpfcnpj)
          : maskCNPJ(cpfcnpj),
      }
    });
  };

  onOK = () => {
    const { registro } = this.state;

    // console.log('onOK: ', registro);

    const PFJ = limparCpfCnpj(registro.emp_cpf_cnpj);
    if (PFJ.length === 11 && /^[0-9]+$/.test(PFJ)) {
      if (!CPFValido(PFJ)) {
        Modal.warning({
          title: 'Aviso!',
          content: 'CPF Inválido',
        });
        return;
      }
    } else {
      if (!CNPJValido(PFJ)) {
        Modal.warning({
          title: 'Aviso!',
          content: 'CNPJ Inválido',
        });
        return;
      }
    }

    if ((!registro.emp_filial) || (registro.emp_filial === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Filial' });
      return;
    }
    if ((!registro.par_local_servidor) || (registro.par_local_servidor === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Servidor' });
      return;
    }
    if (registro.emp_licencas === '') {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Qtde de Licenças' });
      return;
    }
    if ((!registro.emp_nome) || (registro.emp_nome === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Nome' });
      return;
    }
    if ((!registro.emp_razao_social) || (registro.emp_razao_social === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Razão Social' });
      return;
    }
    if ((!registro.emp_municipio) || (registro.emp_municipio.key === '0') || (registro.emp_municipio.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Município' });
      return;
    }
    if ((!registro.emp_data_contrato) || (!moment(registro.emp_data_contrato, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data Válida' });
      return;
    }

    if ((registro.imgNome) && (parseInt(registro.imgSize) > 0) && (parseInt(registro.imgSize) > 100000)) {
      Modal.warning({
        title: 'Imagem Inválida',
        content: 'Imagem muito grande.',
        okText: 'OK',
      })
    }


    const reg = {
      ...registro,

      emp_cpf_cnpj: limparCpfCnpj(registro.emp_cpf_cnpj),
      emp_municipio: registro.emp_municipio ? registro.emp_municipio.key : 0,
      emp_cep: registro.emp_cep ? String(registro.emp_cep).replace(/[^0-9]/g, '') : '',
      emp_data_contrato: registro.emp_data_contrato ? moment(registro.emp_data_contrato, 'DD/MM/YYYY').format('YYYY-MM-DD') : '',
      emp_vlr_mensal: registro.emp_vlr_mensal ? parseFloat(registro.emp_vlr_mensal) : 0,
    };

    console.log('onOK: ', reg);

    this.props.onSalvarClick(reg);
  };

  handleChange = info => {
    // console.log('handleChange: ', info);

    const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png';
    if (!isJpgOrPng) {
      return;
    }
    const isLt2M = info.file.size / 1024 / 1024 < 0.1;
    if (!isLt2M) {
      return;
    }

    this.setState({
      registro: {
        ...this.state.registro,
        imgNome: '',
        imgSize: '',
        imgData: '',
        pathImagem: '',
        base64: '',
      },
    });

    getBase64(info.file.originFileObj, imageUrl =>
      this.setState({
        registro: {
          ...this.state.registro,
          imgNome: info.file.name,
          imgSize: info.file.size,
          imgData: info.file.lastModifiedDate,
          pathImagem: '',
          base64: imageUrl,
        },
        loading: false,
      }),
    );
  };

  onRemoveImage = (file) => {
    const { confirm } = Modal
    return new Promise((resolve, reject) => {
      confirm({
        title: 'Deseja Excluir a Logo?',
        onOk: () => {
          resolve(true)
          this.setState({
            registro: {
              ...this.state.registro,
              imgNome: '',
              imgSize: '',
              imgData: '',
              pathImagem: '',
              base64: '',
            },
          });
        },
        onCancel: () => {
          reject(true)
        }
      })
    })
  }





  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { emp_codigo, emp_nome, emp_razao_social, emp_cpf_cnpj, emp_cep, emp_endereco, emp_complemento,
      emp_bairro, emp_numero, emp_municipio, emp_fone1, emp_fone2, emp_fone3, emp_filial, emp_filial1,
      emp_data_contrato, emp_vlr_mensal, emp_obs, par_local_servidor, par_codigo_liberar_senha,
      // par_entrega_itens_vendas, emp_licencas, par_flag_impr_ped_sem_descon, par_exportar_orcamentos, par_chave_api_google,
      base64, pathImagem
    } = this.state.registro;

    // console.log('EmpresaForm: ', this.state);

    const uploadButton = (
      <div>
        {this.state.loading ? <Icon type="loading" style={{ color: 'rgba(0,0,0,0.4)' }} /> : <Icon type="plus" style={{ color: 'rgba(0,0,0,0.4)' }} />}
        <div className="ant-upload-text">Logo</div>
      </div>
    );


    return (
      <Modal
        title={emp_codigo ? "Edição de Empresa" : "Cadastro de Empresa"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"60%"}
        style={{ top: 30 }}
      >

        <div className="card-container" style={{ minHeight: 0 }}>

          <Form>
            <Row>
              <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
                <span>Código</span>
                <InputForm
                  id="emp_codigo"
                  value={emp_codigo}
                  readOnly
                />
              </Col>

              <Col xs={24} sm={8} style={{ paddingRight: 20 }}>
                <span>CPF/CNPJ</span>
                <InputForm
                  id="emp_cpf_cnpj"
                  ref="emp_cpf_cnpj"
                  maxLength={18}
                  onChange={this.onChange}
                  value={emp_cpf_cnpj}
                  validator={value => Boolean(value)}
                  onBlur={this.normalizeCpfCnpj}
                />
              </Col>

              <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
                <span>Filial</span>
                <InputForm
                  id="emp_filial"
                  ref="emp_filial"
                  value={emp_filial}
                  maxLength={10}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
                <span>Filial Aux</span>
                <InputForm
                  id="emp_filial1"
                  ref="emp_filial1"
                  value={emp_filial1}
                  maxLength={10}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={4} style={{}}>
                <span>Servidor</span>
                <InputForm
                  id="par_local_servidor"
                  ref="par_local_servidor"
                  value={par_local_servidor}
                  maxLength={50}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              {/* <Col xs={24} sm={4} style={{ paddingRight: 20 }}>
                <span>Qtde Licenças</span>
                <InputForm
                  id="emp_licencas"
                  ref="emp_licencas"
                  value={emp_licencas}
                  maxLength={3}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col> */}

              <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Nome</span>
                <InputForm
                  id="emp_nome"
                  ref="emp_nome"
                  maxLength={30}
                  onChange={this.onChange}
                  value={emp_nome}
                  validator={value => Boolean(value)}
                  errorMessage="Informe o Nome"
                  required
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <span>Razão Social</span>
                <InputForm
                  id="emp_razao_social"
                  ref="emp_razao_social"
                  maxLength={30}
                  onChange={this.onChange}
                  value={emp_razao_social}
                  validator={value => Boolean(value)}
                  errorMessage="Informe a Razão Social"
                  required
                />
              </Col>

              <Col xs={24} sm={10} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Endereço</span>
                <InputForm
                  id="emp_endereco"
                  ref="emp_endereco"
                  maxLength={200}
                  onChange={this.onChange}
                  value={emp_endereco}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={10} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Complemento</span>
                <InputForm
                  id="emp_complemento"
                  ref="emp_complemento"
                  maxLength={100}
                  onChange={this.onChange}
                  value={emp_complemento}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: -20 }}>
                <span>Nº</span>
                <InputForm
                  id="emp_numero"
                  ref="emp_numero"
                  maxLength={5}
                  onChange={this.onChange}
                  value={emp_numero}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>Bairro</span>
                <InputForm
                  id="emp_bairro"
                  ref="emp_bairro"
                  maxLength={60}
                  onChange={this.onChange}
                  value={emp_bairro}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={4} style={{ marginTop: -20, paddingRight: 20 }}>
                <span>CEP</span>
                <InputForm
                  id="emp_cep"
                  ref="emp_cep"
                  value={emp_cep}
                  maxLength={10}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                <MunicipioFrame
                  label="Município"
                  id="emp_municipio"
                  value={emp_municipio}
                  width={"100%"}
                  onChange={this.onChangeMunicipio}
                  descricaoPrimeiroItem="Todos os Municípios"
                />
              </Col>

              <Col xs={24} sm={5} style={{ paddingRight: 10, marginTop: -20 }}>
                <span>Telefone</span>
                <InputForm
                  id="emp_fone1"
                  ref="emp_fone1"
                  value={emp_fone1}
                  maxLength={15}
                  masker={maskTelefone}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={5} style={{ paddingRight: 10, marginTop: -20 }}>
                <span>Telefone</span>
                <InputForm
                  id="emp_fone2"
                  ref="emp_fone2"
                  value={emp_fone2}
                  maxLength={15}
                  masker={maskTelefone}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={5} style={{ paddingRight: 10, marginTop: -20 }}>
                <span>Telefone</span>
                <InputForm
                  id="emp_fone3"
                  ref="emp_fone3"
                  value={emp_fone3}
                  maxLength={15}
                  masker={maskTelefone}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={3} style={{ paddingRight: 10, marginTop: -20 }}>
                <span>Valor</span>
                <InputForm
                  type="number"
                  id="emp_vlr_mensal"
                  ref="emp_vlr_mensal"
                  value={emp_vlr_mensal}
                  onChange={this.onChange}
                />
              </Col>

              <Col xs={24} sm={6} style={{ marginTop: -22 }}>
                <span>Data Contrato</span>
                <InputForm
                  type="date"
                  id="emp_data_contrato"
                  ref="emp_data_contrato"
                  value={emp_data_contrato}
                  masker={maskDate}
                  validator={data => moment(data, "DD/MM/YYYY", true).isValid()}
                  dateFormat="DD/MM/YYYY"
                  onChange={this.onChange}
                  errorMessage="Formato correto DD/MM/AAAA"
                  required
                  className="input-data-avaliacao"
                />
              </Col>


              <Col xs={24}>
                <Col xs={24} sm={5} style={{ marginTop: -20 }}>
                  <span>Cód Liberação Senha</span>
                  <InputForm
                    id="par_codigo_liberar_senha"
                    ref="par_codigo_liberar_senha"
                    value={par_codigo_liberar_senha}
                    maxLength={10}
                    onChange={this.onChange}
                    validator={value => Boolean(value)}
                  />
                </Col>
              </Col>

              <Col xs={19} style={{ marginTop: -20 }}>
                <span>Observações</span>
                <InputForm
                  id="emp_obs"
                  ref="emp_obs"
                  value={emp_obs}
                  type="textarea"
                  rows={5}
                  maxLength={9500}
                  onChange={this.onChange}
                  validator={value => Boolean(value)}
                />
              </Col>

              <Col xs={24} sm={5} style={{ marginTop: 0, paddingLeft: 30 }}>
                <div>
                  <Tooltip title="Carregar Logo" placement="topLeft">
                    <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-uploader"
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={this.handleChange}
                    >
                      {base64 || pathImagem ? <img src={base64 ? base64 : pathImagem} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                    </Upload>
                  </Tooltip>
                  {base64 || pathImagem ? (
                    <Col xs={24} style={{ marginTop: -40 }}>
                      <Tooltip title="Excluir Imagem" placement="right">
                        <Button
                          type="ghost"
                          htmlType="button"
                          loading={carregando}
                          onClick={this.onRemoveImage}
                          icon="delete"
                          className="botoesModalFormExcluir"
                        ></Button>
                      </Tooltip>
                    </Col>
                  ) : null}
                </div>
              </Col>

            </Row>
          </Form>

        </div>


        <div>
          <ItemForm>
            <Row>
              <Col xs={24}>
                <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EmpresaForm.js